(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("@kizmann/pico-js"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "@kizmann/pico-js"], factory);
	else if(typeof exports === 'object')
		exports["Nano"] = factory(require("vue"), require("@kizmann/pico-js"));
	else
		root["Nano"] = factory(root["Vue"], root["pi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__122__, __WEBPACK_EXTERNAL_MODULE__55__) => {
return 